<template>
  <div class="personalData">
    <div class="topClass">
      <h3>{{ $t('personal.information') }}</h3>
    </div>
    <div class="conClass">
      <div class="box">
        <div class="imgBox">
          <Uploadify
            :options="options"
            ref="uploadify"
            @getOssRes="getOssRes"
            v-has="'WSS-5001-repassword'"
          >
          </Uploadify>
          <img v-if="userImg" :src="userImg" alt="" />
<!--          <img v-else src="@/assets/images/home/z" alt="" />-->
        </div>
        <div class="br"></div>
        <div class="massage">
          <p>{{ $t('personal.account') }}：&nbsp;{{ acount }}</p>
          <p>{{ $t('personal.until') }}：&nbsp;{{ packageValidity }}</p>
          <p>{{ $t('personal.Package') }}：&nbsp;{{ packageName }}</p>
          <p>{{ $t('personal.Name') }}：&nbsp;{{ userName }}</p>
<!--          <p>-->
<!--            <Button-->
<!--              type="primary"-->
<!--              @click="changePwd"-->
<!--              v-has="'WSS-5001-repassword'"-->
<!--              >修改登录密码</Button-->
<!--            >-->
<!--          </p>-->
<!--          <span style="font-size: 12px; color: #cecece"-->
<!--            >注意：密码修改后，会更改您负责的所有店铺的登录密码。</span-->
<!--          >-->
        </div>
      </div>
      <!-- 修改密码 -->
      <Modal v-model="modelShow" :mask="false">
        <p slot="header" style="font-weight: bold; text-align: center">
          <span>修改登录密码</span>
        </p>
        <div>
          <Form
            ref="formValidate"
            :model="formValidate"
            :rules="ruleValidate"
            :label-width="157"
          >
            <FormItem label="手机号码：">
              <span>{{ acount }}</span>
            </FormItem>
            <FormItem label="验证码：" prop="code" class="code">
              <Row>
                <Col span="14">
                  <Input
                    v-model="formValidate.code"
                    placeholder="请输入验证码"
                  ></Input
                ></Col>
                <Col span="10" style="text-align: right"
                  ><Button
                    type="primary"
                    @click="getCode('formValidate')"
                    :disabled="disabled"
                    >{{ btnText }}</Button
                  ></Col
                >
              </Row>
            </FormItem>
            <FormItem label="新密码：" prop="passwd">
              <Input
                v-model="formValidate.passwd"
                type="password"
                placeholder="请输入您的新密码"
              ></Input>
            </FormItem>
            <FormItem label="确认密码：" prop="password">
              <Input
                @paste.native.capture.prevent="handleFalse"
                @copy.native.capture.prevent="handleFalse"
                @cut.native.capture.prevent="handleFalse"
                v-model="formValidate.password"
                type="password"
                placeholder="请再次输入您的密码"
              ></Input>
            </FormItem>
          </Form>
        </div>
        <div slot="footer" style="text-align: center">
          <Button @click="handleSubmit('formValidate')" type="primary"
            >确认</Button
          >

          <Button @click="modelShow = false">取消</Button>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
// import { setImgs } from '@/api/myweb/goods/goodsManagement'

import { getPersonalData, passwd, getCodeSMS, changeAvatar } from '@/api/user'
import { mapActions } from 'vuex'
import Utils from '@/libs/util.js'
import Uploadify from '@/views/base/uploadify/upload.vue'
export default {
  components: { Uploadify },
  data() {
    const validatePassCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请您重新输入您的密码'))
      } else if (value !== this.formValidate.passwd) {
        callback(new Error('确认密码与登录密码不一样'))
      } else {
        callback()
      }
    }
    return {
      options: {
        size: 2,
        optionbtn: false,
        optionbtn1: false,
        edit: false,
        tips: true,
        fileType: ['jpg', 'png', 'jpeg', 'gif']
      },
      formValidate: {
        phone: '',
        code: '',
        passwd: '',
        password: '',
        deviceId: ''
        // userChangePasswd:1
      },
      ruleValidate: {
        code: [
          {
            required: true,
            message: '验证码不能为空',
            trigger: 'blur'
          }
        ],
        passwd: [
          {
            required: true,
            message: '登录密码不能为空',
            trigger: 'blur'
          },
          {
            type: 'string',
            min: 8,
            message: '长度必须8位及以上',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            validator: validatePassCheck,
            trigger: 'blur'
          }
        ]
      },
      totalCount: 0,
      disabled: false, // 控制按钮是否可以点击（false:可以点击，true:不可点击）
      modelShow: false,
      acount: '',
      packageValidity: '2023年12月31日',
      packageName: '高级套餐',
      userName: localStorage.getItem('staffName'),
      userImg: JSON.parse(localStorage.getItem('userData')).avatar
    }
  },
  created() {
    // this.getAcount()
  },
  mounted() {
    this.getPersonalDataFun()
  },
  computed: {
    btnText() {
      return this.totalCount !== 0
        ? `${this.totalCount}秒再次获取`
        : '获取短信验证码'
    }
  },
  methods: {
    // ...mapActions(['handleLogin']),
    handleFalse() {
      //终止
      return false
    },
    async getPersonalDataFun() {
      let res = await getPersonalData()
      if (res.status) {
        this.acount = res.data.username
        this.formValidate.phone = res.data.username
        this.packageValidity = res.data.endTime
        this.packageName = res.data.serviceName
        this.userName = res.data.acountName
      } else {
        this.$message.error(res.message)
      }
    },
    // 账号处理
    getAcount() {
      let a = JSON.parse(localStorage.getItem('userData')).phone.split('')
      this.formValidate.phone = JSON.parse(
        localStorage.getItem('userData')
      ).phone
      a.splice(3, 4, '****')
      // this.acount = a.join('')
      this.acount = this.formValidate.phone
    },
    // 上传头像
    getOssRes(res) {
      console.log(res.url)
      this.changeAvatar(res.url)
      this.userImg = res.url
    },

    // 保存头像
    async changeAvatar(avatar) {
      let res = await changeAvatar({
        avatar
      })
      console.log(res)
      localStorage.userData = JSON.stringify(res.data.userInfo)
      // this.handleLogin()
      // this.$bus.emit('avatarEvent')
      Utils.$emit('demo', avatar)
    },
    // 打开模态框
    changePwd() {
      this.$refs.formValidate.resetFields()
      this.modelShow = true
    },
    // 获取短信验证码
    async getCode() {
      const res = await getCodeSMS({
        phone: this.formValidate.phone,
        platformCode: 'JP-WSS',
        type: 1
      })
      if (res.code == 0) {
        console.log(res)
        this.formValidate.deviceId = res.data
      }
      console.log(res)
      // 按钮60秒倒计时
      this.disabled = true
      this.totalCount = 60
      this.interval = setInterval(() => {
        this.totalCount--
        if (this.totalCount === 0) {
          clearInterval(this.interval)
          this.disabled = false
        }
      }, 1000)
    },
    ...mapActions(['handleLogOut']),
    loginOut() {
      const deviceId = localStorage.getItem('deviceId')
      var storage = window.localStorage
      storage.clear()
      this.handleLogOut({}).then(() => {
        this.$router.push({
          path: '/'
        })

        console.log(deviceId)
        window.location.reload()
        localStorage.setItem('deviceId', deviceId)
      })
    },
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          console.log(this.formValidate)
          const res = await passwd(this.formValidate)
          console.log(res)
          if (res.status) {
            this.$Message.success('修改成功，请重新登录')
            this.modelShow = false
            setTimeout(() => {})
            this.loginOut(), 300
          }
        } else {
          this.$Message.error('请输入必填项')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
